'use strict';

angular.module('amexReconciliationApp')
  .directive('noNewline', function noNewline() {

    function link(scope, element) {
      element.bind('keydown', function (event) {
        if (event.keyCode === 13) {
          event.preventDefault();
        }
      });
    }

    return {
      link: link
    };

  });



//////////////////
// WEBPACK FOOTER
// ./src/main/resources/static/scripts/directives/noNewline.js
// module id = 527
// module chunks = 0